









// <ywhz-title-card title="台集運 · 線路介紹" subtitle="TAIWAN CONSOLIDATION"></ywhz-title-card>
import { Component, Prop, Vue } from 'vue-property-decorator';
@Component({
    name: 'TitleCard',
    components: {}
})
export default class TitleCard extends Vue {
    @Prop({
        type: String,
        default: () => ''
    })
    public title: string;

    @Prop({
        type: String,
        default: () => ''
    })
    public subtitle: string;
}
